import React, { Component } from 'react'
import * as R from 'ramda'
import { Tabs } from 'antd-mobile'
import cx from 'classnames'
import { ZAShow } from 'za-react'
import Card from '../../components/Card'
import DynamicDetailsModule from '../../modules/DynamicDetails'
import AnswerList from '../../modules/AnswerList'
import IdeaList from '../../modules/IdeaList'
import { getDynamicInfo } from '../../services'
import styles from './ActivityParticipate.css'

export default class ActivityParticipate extends Component {
  state = {
    answerListTab: 0,
    dynamicInfo: {},
    totalCount: 0,
    isLoading: true,
  }

  componentDidMount = () => {
    this.loadData()
  }

  componentDidUpdate = prevProps => {
    if (
      R.path('match.params.dynamicId', this.props) !==
        R.path('match.params.dynamicId', prevProps) ||
      this.props.dynamicId !== prevProps.dynamicId
    ) {
      this.loadData()
    }
  }

  handleAnswerListChange = data => {
    this.setState({ totalCount: data.totalCount })
  }

  loadData = () => {
    const {
      dynamicId: queryDynamicId,
      match: { params: { dynamicId: paramDynamicId } = {} } = {},
      hideAward,
    } = this.props
    const dynamicId = paramDynamicId || queryDynamicId

    if (dynamicId) {
      getDynamicInfo({ dynamicId }).then(result => {
        const { data } = result
        this.setState({
          answerListTab: hideAward || data.awardsAnswerCount >= 3 ? 0 : 1,
          dynamicInfo: data,
          isLoading: false,
        })
      })
    }
  }

  render() {
    const { answerListTab, dynamicInfo, totalCount, isLoading } = this.state
    const {
      dynamicId: queryDynamicId,
      match: { params: { dynamicId: paramDynamicId } = {} } = {},
      organizationName,
      hideAward,
    } = this.props

    const dynamicId = paramDynamicId || queryDynamicId

    if (!dynamicId || isLoading) {
      return null
    }

    const tabList = hideAward
      ? [{ title: '全部讨论' }]
      : [{ title: '获奖讨论' }, { title: '全部讨论' }]

    return (
      <div>
        <ZAShow zaType="Page" />
        <Card>
          <DynamicDetailsModule dynamicInfo={dynamicInfo} />
          {dynamicInfo.pinTopic && dynamicInfo.pinTopic === 'activity-pin' ? (
            <IdeaList
              dynamicId={dynamicId}
              organizationName={organizationName}
            />
          ) : (
            <div
              className={cx(styles.answerListTabsCard, {
                [styles.answerListTabsCardOther]: hideAward,
              })}
            >
              <Tabs
                tabBarStyle={{ width: 100 }}
                tabs={tabList}
                page={answerListTab}
                tabBarBackgroundColor="#f7f7f7"
                tabBarActiveTextColor="#0084ff"
                tabBarUnderlineStyle={{ backgroundColor: '#0084ff' }}
                onTabClick={(tab, index) => {
                  if (index <= 1) this.setState({ answerListTab: index })
                }}
                animated={false}
                swipeable={false}
              />
              <AnswerList
                answerType={
                  hideAward || answerListTab === 1 ? 'normal' : 'award'
                }
                {...this.props}
                combineProductToken={dynamicInfo.combineProductToken}
                dynamicId={dynamicId}
                onChange={this.handleAnswerListChange}
              />
              <div className={styles.answerCount}>{totalCount}个回答</div>
            </div>
          )}
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Activity/ActivityParticipate.js